export function updateIsMustReviewFlg(takeTrainignId){
	var isMustReviewFlg = document.getElementById("isMustReviewFlgId").value;
	if(isMustReviewFlg == 'true'){
		isMustReviewFlg = 'false';
	}else{
		isMustReviewFlg = 'true';
	}
	
	var xhttp = new XMLHttpRequest();
	xhttp.onreadystatechange = function() {
	    if (this.readyState == 4 && this.status == 200) {
	    	var resp = this.responseText;
	    	document.getElementById("isMustReviewFlgId").value = resp;
	    }
	  };
	xhttp.open("GET", "/trainings/updateIsMustReviewFlg?flg=" + isMustReviewFlg + "&tki=" + takeTrainignId, true);
	xhttp.send();
}

